export const MS_ONE_DAY = 24 * 60 * 60 * 1000;
export const MS_SEVEN_DAYS = 7 * MS_ONE_DAY;
export const MS_SIX_DAYS = 6 * MS_ONE_DAY;
export const MS_THIRTY_DAYS = 30 * MS_ONE_DAY;
export const MS_SIX_MONTHS = 179 * MS_ONE_DAY;
export const TIME_ZERO = [0, 0, 0, 0];
export const END_OF_DAY = [23, 59, 59, 0];
export const DATE_FORMAT_MMDDYYYY = "MM/DD/YYYY";
export const DATE_FORMAT_MMM_DD_YYYY = "MMM DD, YYYY";
export const MIN_DATE = new Date(1988, 1, 1);
export const HOUR_24_MINUTE_FORMAT = "HH:mm";
export const MONTH_DATE_YEAR_HR_MIN_SEC_AM = "MMM DD YYYY HH:mm:ss A";
export const HR_MIN_AM = "h:mm A";
export const MONTH_DD_YYY_HR_MIN_SEC_AM_ZZZ = "MMM DD, YYYY, hh:mm:ss A z";
export const HR_MIN_SEC_AM_ZZZ = "hh:mm:ss A z";
export const MONTH_DD_YYYY_Z = "MM/DD/YYYY z";
export const MONTH_DATE_YYYY_WITH_COMA = "MMM D, YYYY,"



export const datepickerListitems = [
  { id: 1, text: "Custom" },
  { id: 2, text: "Today" },
  { id: 3, text: "Yesterday" },
  { id: 4, text: "Last 7 days" },
  { id: 5, text: "Last 30 days" },
  { id: 6, text: "Last 6 months" },
  { id: 7, text: "Year to date" },
  { id: 8, text: "Last year" },
];
